
import React from 'react';
import { NavLink, Service, InfoItem, FAQItem } from './types';

export const ToothIcon: React.FC<{ className?: string }> = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 4.5l7.5 7.5-7.5 7.5M11.25 4.5l-7.5 7.5 7.5 7.5" /> {/* Placeholder, real tooth icon would be better */}
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21.75C6.477 21.75 2 17.273 2 11.75S6.477 1.75 12 1.75s10 4.477 10 10-4.477 10-10 10zm0-3a7 7 0 100-14 7 7 0 000 14z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 11.75c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-3a3 3 0 00-3 3v.5a.5.5 0 00.5.5h5a.5.5 0 00.5-.5v-.5a3 3 0 00-3-3z" />
  </svg>
);

export const CalendarIcon: React.FC<{ className?: string }> = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-3.75h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zm3-4.5h.008v.008H12.75v-.008zm0 2.25h.008v.008H12.75V15zm3-2.25h.008v.008H15.75v-.008zm0 2.25h.008v.008H15.75V15z" />
  </svg>
);

export const ShieldCheckIcon: React.FC<{ className?: string }> = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622A11.99 11.99 0 0018.402 6a11.959 11.959 0 01-2.036-1.286A11.977 11.977 0 0012 2.75c-2.432 0-4.707.726-6.602 2.014z" />
  </svg>
);

export const InformationCircleIcon: React.FC<{ className?: string }> = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
  </svg>
);

export const UsersIcon: React.FC<{ className?: string }> = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
  </svg>
);

export const PhoneIcon: React.FC<{ className?: string }> = ({ className = "w-6 h-6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.018-.991-.053-1.467l-.092-.919a2.25 2.25 0 00-1.074-1.905l-3.328-1.664a2.25 2.25 0 00-2.488.163l-1.12 1.12c-.933-.504-1.805-1.066-2.614-1.687s-1.579-1.252-2.223-2.034l1.12-1.12a2.25 2.25 0 00.163-2.488l-1.664-3.328a2.25 2.25 0 00-1.905-1.074l-.919-.092a23.182 23.182 0 00-1.467-.053H2.25z" />
  </svg>
);

export const AcademicCapIcon: React.FC<{ className?: string }> = ({ className = "w-6 h-6" }) => (
 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path d="M12 14l9-5-9-5-9 5 9 5z" />
    <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
  <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5zm0 0v5.5A2.5 2.5 0 0014.5 22h.086a2.5 2.5 0 002.414-2.179M12 14L2.091 9.091A2.5 2.5 0 00.25 11.179V19.5A2.5 2.5 0 002.75 22h.086A2.5 2.5 0 005.25 19.821" />
</svg>
);


export const NAV_LINKS: NavLink[] = [
  { id: "about", label: "O Dentobusie", href: "#about" },
  { id: "services", label: "Usługi", href: "#services" },
  { id: "schedule", label: "Harmonogram", href: "#schedule" },
  { id: "parents", label: "Dla Rodziców", href: "#parents" },
  { id: "tips", label: "Porady", href: "#tips" },
  { id: "contact", label: "Kontakt", href: "#contact" },
];

export const SERVICES_DATA: Service[] = [
  {
    id: "checkup",
    title: "Przeglądy Stomatologiczne",
    description: "Regularne kontrole stanu zdrowia jamy ustnej, wykrywanie wczesnych problemów.",
    Icon: ToothIcon,
  },
  {
    id: "fluoridation",
    title: "Fluoryzacja",
    description: "Zabieg wzmacniający szkliwo zębów i chroniący przed próchnicą.",
    Icon: ShieldCheckIcon,
  },
  {
    id: "sealing",
    title: "Lakowanie Zębów",
    description: "Zabezpieczanie bruzd zębów trzonowych i przedtrzonowych specjalnym lakiem.",
    Icon: ShieldCheckIcon,
  },
  {
    id: "education",
    title: "Edukacja Zdrowotna",
    description: "Nauka prawidłowej higieny jamy ustnej i zdrowych nawyków żywieniowych.",
    Icon: AcademicCapIcon,
  },
];

export const PARENT_INFO_ITEMS: InfoItem[] = [
  {
    id: "consent",
    title: "Zgoda na Badanie",
    content: "Przed wizytą w Dentobusie wymagana jest pisemna zgoda rodzica lub opiekuna prawnego. Formularze są dostępne u nauczycieli lub do pobrania na stronie NFZ.",
    Icon: InformationCircleIcon,
  },
  {
    id: "benefits",
    title: "Korzyści z Wizyt",
    content: "Regularne wizyty pomagają w utrzymaniu zdrowych zębów, zapobiegają bólowi i kosztownemu leczeniu w przyszłości.",
    Icon: ToothIcon,
  },
  {
    id: "preparation",
    title: "Przygotowanie Dziecka",
    content: "Porozmawiaj z dzieckiem o wizycie w pozytywny sposób. Wyjaśnij, że dentysta pomaga dbać o piękny uśmiech. Unikaj straszenia.",
    Icon: UsersIcon,
  },
];

export const DENTAL_TIPS: InfoItem[] = [
  {
    id: "brushing",
    title: "Myj Zęby Regularnie",
    content: "Szczotkuj zęby co najmniej dwa razy dziennie przez 2 minuty pastą z fluorem.",
    Icon: ToothIcon,
  },
  {
    id: "diet",
    title: "Zdrowa Dieta",
    content: "Ogranicz słodycze i słodkie napoje. Jedz dużo warzyw i owoców.",
    Icon: ShieldCheckIcon,
  },
  {
    id: "checkups",
    title: "Odwiedzaj Dentystę",
    content: "Regularne wizyty kontrolne w Dentobusie pomogą utrzymać Twój uśmiech w doskonałej formie!",
    Icon: CalendarIcon,
  },
];

export const FAQ_DATA: FAQItem[] = [
  {
    id: "faq1",
    question: "Czy usługi Dentobusu są płatne?",
    answer: "Nie, wszystkie usługi świadczone w ramach programu Dentobus NFZ są bezpłatne dla dzieci i młodzieży do 18. roku życia.",
  },
  {
    id: "faq2",
    question: "Jak często Dentobus odwiedza daną szkołę/miejscowość?",
    answer: "Harmonogram wizyt jest ustalany przez lokalne oddziały NFZ. Prosimy sprawdzać aktualne informacje w szkole lub na stronie NFZ.",
  },
  {
    id: "faq3",
    question: "Czy moje dziecko otrzyma leczenie kanałowe w Dentobusie?",
    answer: "Dentobus świadczy podstawowe usługi profilaktyczne i lecznicze. W przypadku bardziej skomplikowanych zabiegów, dziecko może zostać skierowane do stacjonarnego gabinetu stomatologicznego.",
  },
];
